import React, { useState } from 'react';

import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";
const DivisionCarnival = () => {
  const [score, setScore] = useState(0);
  const [hintTokens, setHintTokens] = useState(3);
  const [division, setDivision] = useState({});
  const [steps, setSteps] = useState([]);
  const [userSteps, setUserSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [challengeText, setChallengeText] = useState('');
  const [result, setResult] = useState('');
  const [prize, setPrize] = useState('');
  const [wheelStyle, setWheelStyle] = useState({});

  const generateDivision = () => {
    const divisor = Math.floor(Math.random() * 8 + 2); // 2 to 9
    const dividend = Math.floor(Math.random() * 900 + 10);
    const adjustedDividend = dividend - (dividend % divisor);
    return { dividend: adjustedDividend, divisor };
  };

  const getSteps = (dividend, divisor) => {
    const digits = dividend.toString().split('').map(Number);
    const steps = [];
    let remainder = 0;
    for (let digit of digits) {
      remainder = remainder * 10 + digit;
      steps.push(Math.floor(remainder / divisor));
      remainder %= divisor;
    }
    return steps;
  };

  const spinWheel = () => {
    const angle = Math.floor(Math.random() * 360 + 720);
    setWheelStyle({ transform: `rotate(${angle}deg)` });
    setTimeout(startChallenge, 2000);
  };

  const startChallenge = () => {
    const div = generateDivision();
    const divSteps = getSteps(div.dividend, div.divisor);
    setDivision(div);
    setSteps(divSteps);
    setCurrentStep(0);
    setUserSteps([]);
    setChallengeText(`🎉 Solve: ${div.dividend} ÷ ${div.divisor}`);
    setResult('');
    setPrize('');
  };

  const submitStep = () => {
    const input = parseInt(document.getElementById("stepInput").value);
    if (input === steps[currentStep]) {
      const newSteps = [...userSteps, input];
      setUserSteps(newSteps);
      if (currentStep + 1 === steps.length) {
        setResult('✨ Correct! You won a balloon!');
        const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
        setScore(score + 1);
        setPrize(getRandomPrize());
        setChallengeText('');
      } else {
        setCurrentStep(currentStep + 1);
        document.getElementById("stepInput").value = '';
      }
    } else {
      setResult('❌ Try again!');
    }
  };

  const showHint = () => {
    if (hintTokens > 0) {
      setHintTokens(hintTokens - 1);
      setResult(`Hint: Step ${currentStep + 1} = ${steps[currentStep]}`);
    } else {
      setResult('⚠️ No hint tokens left!');
    }
  };

  const getRandomPrize = () => {
    const prizes = ['🧶 Teddy Bear', '🎈 Balloon', '🎠 Plush Toy', '🎭 Clown Hat', '🎒 Magic Wand'];
    return `You won: ${prizes[Math.floor(Math.random() * prizes.length)]}!`;
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>✨ Division Carnival ✨</h1>

      <div style={{ ...styles.wheel, ...wheelStyle }}>
        <div style={styles.pointer}></div>
      </div>

      <button style={styles.button} onClick={spinWheel}>Spin the Wheel!</button>

      <div style={styles.challengeText}>{challengeText}</div>

      {challengeText && (
        <div style={styles.inputSection}>
          <label style={styles.label}>
            Step <strong>{currentStep + 1}</strong>:
            <input
              type="number"
              id="stepInput"
              style={styles.input}
            />
          </label>
          <div style={styles.buttonRow}>
            <button onClick={submitStep} style={styles.button}>Submit</button>
            <button onClick={showHint} style={styles.hintButton}>🌟 Use Hint Token</button>
          </div>
        </div>
      )}

      <div style={styles.feedback}>{result}</div>
      <div style={styles.status}>Score: {score} | 🌟 Hint Tokens: {hintTokens}</div>
      <div style={styles.prize}>{prize}</div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Comic Sans MS, cursive',
    background: 'linear-gradient(to bottom, #ffe082, #ffccbc)',
    padding: '2rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  title: {
    color: '#d84315',
    fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
    marginBottom: 20
  },
  wheel: {
    position: 'relative',
    width: 'clamp(150px, 40vw, 220px)',
    height: 'clamp(150px, 40vw, 220px)',
    borderRadius: '50%',
    border: '10px solid #f06292',
    background: 'conic-gradient(#81c784 0% 33%, #64b5f6 33% 66%, #ffd54f 66% 100%)',
    marginBottom: 20,
    transition: 'transform 2s ease-out'
  },
  pointer: {
    position: 'absolute',
    top: -30,
    left: 'calc(50% - 20px)',
    width: 0,
    height: 0,
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',
    borderBottom: '30px solid #d32f2f'
  },
  challengeText: {
    fontSize: 'clamp(1.1rem, 4vw, 1.4rem)',
    margin: '10px 0'
  },
  inputSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    marginTop: 15,
    width: '100%',
    maxWidth: '400px'
  },
  label: {
    fontSize: 'clamp(1rem, 3.5vw, 1.2rem)',
    display: 'block',
    width: '100%',
    textAlign: 'center'
  },
  input: {
    fontSize: 'clamp(1rem, 3.5vw, 1.2rem)',
    padding: '8px',
    marginTop: '10px',
    width: '80%',
    maxWidth: '350px',
    textAlign: 'center',
    margin:'0 auto'
  },
  buttonRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 10
  },
  button: {
    background: '#4fc3f7',
    color: 'white',
    padding: '10px 20px',
    fontSize: 'clamp(1rem, 3vw, 1.1rem)',
    border: 'none',
    borderRadius: 10,
    cursor: 'pointer'
  },
  hintButton: {
    background: '#fdd835',
    fontSize: 'clamp(1rem, 3vw, 1.1rem)',
    border: 'none',
    padding: '10px 20px',
    borderRadius: 10,
    cursor: 'pointer'
  },
  feedback: {
    marginTop: 15,
    fontSize: 'clamp(1rem, 3.5vw, 1.3rem)',
    color: '#d32f2f',
    fontWeight: 'bold'
  },
  status: {
    marginTop: 15,
    fontSize: 'clamp(1rem, 3.5vw, 1.3rem)',
    fontWeight: 'bold'
  },
  prize: {
    marginTop: 15,
    fontSize: 'clamp(1rem, 3.5vw, 1.3rem)',
    color: '#2e7d32',
    fontWeight: 'bold'
  }
};

export default DivisionCarnival;
